import * as React from "react";
import ButtonGroupWrapper from "../../../hiberUiKit/src/atoms/Buttons/ButtonGroupWrapper";
import PageHeaderView from "../../body/PageHeaderView";
import ButtonPrimary from "../../../hiberUiKit/src/atoms/Buttons/ButtonPrimary";
import PageContentView from "../../body/PageContentView";
import ManageAssetsTable from "./ManageAssetsTable";
import {none, option, Option} from "ts-option";
import AssetAttribute from "../../../model/assetAttribute/AssetAttribute";
import {RootState} from "../../../store/reducer/root/RootState";
import {connect, Dispatch} from "react-redux";
import {fetchAssetAttributes} from "../../../store/action/assetAttribute/assetAttribute";
import {notifyBugsnagAndShowToast} from "../../../utils/Utils";
import {OnFailure} from "../../../store/action/actionHelpers";
import Loading from "../../ui/loading/Loading";
import {api} from "../../../api/api";
import Toast from "../../helper/Toast";
import UploadAssetModal from "../assets/modal/UploadAssetModal";

interface ReduxProps {
	/**
	 * Asset attributes list
	 */
	assetAttributes: Option<AssetAttribute[]>;
}

interface DispatchProps {
	/**
	 * Fetch asset attributes.
	 * @param {OnFailure} onFailure
	 */
	fetchAssetAttributes: (onFailure: OnFailure) => void;
}

interface State {
	/**
	 * Selected items headers holder
	 */
	selectedItemsHeaders: string[];
	/**
	 * Selected header holder
	 */
	selectedHeader: Option<string>;
	/**
	 * Indicates if upload asset modal is visible
	 */
	uploadModalVisible: boolean;
}

type Props = ReduxProps & DispatchProps;

class ManageAssetsList extends React.Component<Props, State> {

	constructor(props: Props) {
		super(props);
		this.state = {selectedItemsHeaders: [], selectedHeader: none, uploadModalVisible: false};
		this.onSelectAssetAttribute = this.onSelectAssetAttribute.bind(this);
		this.onExport = this.onExport.bind(this);
		this.onImport = this.onImport.bind(this);
		this.closeUploadAssetsModal = this.closeUploadAssetsModal.bind(this);
	}

	componentDidMount() {
		if (this.props.assetAttributes.isEmpty) {
			this.props.fetchAssetAttributes((error => notifyBugsnagAndShowToast(error, "Fetch assets attributes")));
		}
	}

	render() {
		return (
			<React.Fragment>
				<PageHeaderView header={"Assets attributes"}>
					<ButtonGroupWrapper>
						<ButtonPrimary onClick={this.onExport}
									   label={"Export selected Assets attributes"}
									   variant={"burgundy"}
									   disabled={this.state.selectedItemsHeaders.length === 0}/>
					</ButtonGroupWrapper>
				</PageHeaderView>
				<PageContentView>
					<Loading isLoading={this.props.assetAttributes.isEmpty}>
						<ManageAssetsTable assetAttributes={this.props.assetAttributes.getOrElse([])}
										   onSelect={this.onSelectAssetAttribute}
										   onImport={this.onImport}
										   selectedItemsHeaders={this.state.selectedItemsHeaders}/>
					</Loading>
				</PageContentView>
				{this.state.uploadModalVisible && this.state.selectedHeader.isDefined &&
				<UploadAssetModal onClose={this.closeUploadAssetsModal}
								  assetAttributeHeader={this.state.selectedHeader}/>}
			</React.Fragment>
		)
	}

	onSelectAssetAttribute(selectedItemsHeaders: string[]) {
		this.setState({selectedItemsHeaders});
	}

	onExport() {
		if (this.state.selectedItemsHeaders.length > 0) {
			api.instance.assetApi.downloadAssets(this.state.selectedItemsHeaders).catch(
				() => Toast.error("Cannot download assets", "Assets download"));
		}
	}

	onImport(header: string) {
		this.setState({uploadModalVisible: true, selectedHeader: option(header)});
	}

	closeUploadAssetsModal() {
		this.setState({uploadModalVisible: false});
	}
}

function mapStateToProps(state: RootState) {
	return {
		assetAttributes: state.asset.assetAttributes
	};
}

function mapDispatchToProps(dispatch: Dispatch<any>) {
	return {
		fetchAssetAttributes: (onFailure: OnFailure) => dispatch(
			fetchAssetAttributes(() => {}, onFailure)
		)
	};
}

export default connect(mapStateToProps, mapDispatchToProps)(ManageAssetsList)